import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import vpn from '../app/vpn.module.css';
import classes from './help.module.css';

/**
 * Инструкции для веб-кабинета: Wireguard, AmneziaWG, VLESS — как в miniApp (Помощь), текст под сайт.
 */
const Help = () => {
    const navigate = useNavigate();
    const [openSection, setOpenSection] = useState(0);
    const [protocol, setProtocol] = useState(1); // 0 Wireguard, 1 AmneziaWG, 2 VLESS

    useEffect(() => {
        const token = typeof window !== 'undefined' ? window.localStorage.getItem('efv_web_token') : null;
        if (!token) {
            navigate('/auth');
        }
    }, [navigate]);

    useEffect(() => {
        setOpenSection(0);
    }, [protocol]);

    function toggleSection(n) {
        setOpenSection((prev) => (prev === n ? 0 : n));
    }

    const isWg = protocol === 0;
    const isAmn = protocol === 1;
    const isVless = protocol === 2;

    return (
        <div className={classes.page}>
            <div className={classes.inner}>
                <div className={classes.topRow}>
                    <button type="button" className={classes.backBtn} onClick={() => navigate(-1)}>
                        ← Назад
                    </button>
                    <h1 className={classes.pageTitle}>Инструкция по установке</h1>
                </div>

                <div className={classes.card}>
                    <p className={classes.intro}>
                        Ниже — те же шаги, что в разделе <strong>«Помощь»</strong> в приложении Telegram, но для работы через{' '}
                        <strong>личный кабинет на сайте</strong>. Сначала добавьте VPN-сервер кнопкой{' '}
                        <strong>«Добавить VPN-сервер»</strong>, затем следуйте инструкции для вашего устройства и протокола.
                    </p>
                    <div className={classes.platforms}>
                        <button
                            type="button"
                            className={`${classes.platform} ${protocol === 0 ? classes.platformActive : ''}`}
                            onClick={() => setProtocol(0)}
                        >
                            Wireguard
                        </button>
                        <button
                            type="button"
                            className={`${classes.platform} ${protocol === 1 ? classes.platformActive : ''}`}
                            onClick={() => setProtocol(1)}
                        >
                            AmneziaWG
                        </button>
                        <button
                            type="button"
                            className={`${classes.platform} ${protocol === 2 ? classes.platformActive : ''}`}
                            onClick={() => setProtocol(2)}
                        >
                            VLESS
                        </button>
                    </div>

                    <div className={classes.block3}>
                        <div className={classes.helpBody}>
                        <div className={vpn.infoText1}>Выберите тип вашего устройства</div>
                        <div className={vpn.line} />

                        {/* Android */}
                        <div
                            className={vpn.infoText2}
                            onClick={() => toggleSection(1)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && toggleSection(1)}
                        >
                            Android
                            <svg
                                style={{transform: openSection === 1 ? 'rotate(180deg)' : ''}}
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                            >
                                <path d="M5 8L11 14L17 8" stroke="#FFF" strokeWidth="2" strokeLinecap="square" />
                            </svg>
                        </div>
                        {openSection === 1 && isWg && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете нажмите «Добавить VPN-сервер», выберите протокол <b>Wireguard</b> и страну. В
                                карточке сервера скачайте *.conf или откройте QR-код.
                                <br />
                                2. Установите{' '}
                                <a href="https://play.google.com/store/apps/details?id=com.wireguard.android&hl=ru&gl=US">
                                    приложение WireGuard
                                </a>{' '}
                                для Android.
                                <br />
                                3. Откройте скачанный файл или отсканируйте QR из карточки сервера.
                                <br />
                                4. В WireGuard нажмите ➕ внизу справа.
                                <br />
                                5. «Создать туннель из файла» или импорт по QR; при ошибке имени переименуйте .conf латиницей.
                                <br />
                                6. Включите туннель.
                                <br />
                                <br />
                                <b>Один и тот же QR и файл .conf — только на одном устройстве.</b>
                            </div>
                        )}
                        {openSection === 1 && isAmn && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете на сайте нажмите «Добавить VPN-сервер», выберите протокол AmneziaWG и страну. В
                                карточке сервера скачайте файл конфигурации (*.conf) или откройте QR-код.
                                <br />
                                2. Установите{' '}
                                <a href="https://play.google.com/store/apps/details?id=org.amnezia.awg&hl=ru&gl=US">
                                    приложение AmneziaWG
                                </a>
                                .
                                <br />
                                3. Откройте скачанный *.conf или отсканируйте QR из карточки сервера.
                                <br />
                                4. Запустите AmneziaWG и нажмите ➕ внизу экрана справа.
                                <br />
                                5. Нажмите «Импорт из файла или архива», выберите файл из папки загрузок; при ошибке имени файла
                                переименуйте его латиницей.
                                <br />
                                6. Включите тумблер.
                                <br />
                                <br />
                                QR можно открыть на другом устройстве и отсканировать в AmneziaWG через ➕.
                                <br />
                                <b>Один и тот же QR и файл .conf — только на одном устройстве.</b>
                            </div>
                        )}
                        {openSection === 1 && isVless && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете нажмите <b>«VLESS»</b> в блоке VLESS-подписка
                                и скопируйте одну постоянную ссылку.
                                <br />
                                2. Установите{' '}
                                <a href="https://play.google.com/store/apps/details?id=com.v2raytun.android">приложение V2rayTun</a>.
                                <br />
                                3. В v2rayTun нажмите «+» → Import from clipboard / Add subscription и вставьте ссылку.
                                <br />
                                4. Обновление списка серверов происходит при refresh подписки — выбирать страну и создавать
                                конфиг вручную не нужно.
                                <br />
                                5. Российские сервисы работают напрямую; зарубежный трафик идёт через VPN (в Happ — автоматически).
                                <br />
                                <br />
                                <b>Ссылка подписки секретна: не публикуйте её.</b>
                            </div>
                        )}

                        <div className={vpn.line} />

                        {/* iOS */}
                        <div
                            className={vpn.infoText2}
                            onClick={() => toggleSection(2)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && toggleSection(2)}
                        >
                            iOS (iPhone, iPad)
                            <svg
                                style={{transform: openSection === 2 ? 'rotate(180deg)' : ''}}
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                            >
                                <path d="M5 8L11 14L17 8" stroke="#FFF" strokeWidth="2" strokeLinecap="square" />
                            </svg>
                        </div>
                        {openSection === 2 && isWg && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете выберите протокол <b>Wireguard</b> при добавлении сервера. Скачайте *.conf или
                                откройте QR в карточке.
                                <br />
                                2. Установите{' '}
                                <a href="https://apps.apple.com/ru/app/wireguard/id1441195209">WireGuard для iOS</a>.
                                <br />
                                3. Откройте файл .conf (из «Файлы» или загрузок).
                                <br />
                                4. Нажмите «Поделиться» → выберите WireGuard.
                                <br />
                                5. Подтвердите импорт туннеля и включите его.
                                <br />
                                <br />
                                QR можно отсканировать в WireGuard через ➕.
                                <br />
                                <b>Один и тот же QR и файл .conf — только на одном устройстве.</b>
                            </div>
                        )}
                        {openSection === 2 && isAmn && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете нажмите «Добавить VPN-сервер», выберите AmneziaWG и страну. Скачайте *.conf
                                или откройте QR в карточке сервера.
                                <br />
                                2. Установите{' '}
                                <a href="https://apps.apple.com/ru/app/amneziawg/id6478942365">приложение AmneziaWG</a>.
                                <br />
                                3. Откройте файл конфигурации (из загрузок или по ссылке из кабинета).
                                <br />
                                4. В правом верхнем углу нажмите «Поделиться».
                                <br />
                                5. В списке программ выберите AmneziaWG.
                                <br />
                                6. Включите тумблер.
                                <br />
                                <br />
                                QR можно переслать и отсканировать в AmneziaWG через ➕.
                                <br />
                                <b>Один и тот же QR и файл .conf — только на одном устройстве.</b>
                            </div>
                        )}
                        {openSection === 2 && isVless && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете нажмите <b>«VLESS»</b> и скопируйте одну постоянную ссылку.
                                <br />
                                2. Установите <a href="https://apps.apple.com/app/id6476628951">приложение V2rayTun</a>.
                                <br />
                                3. В v2rayTun: «+» → Import subscription / из буфера обмена.
                                <br />
                                4. Вставьте ссылку и обновите подписку — локации появятся автоматически.
                                <br />
                                5. Российские сервисы работают напрямую; зарубежный трафик идёт через VPN (в Happ — автоматически).
                                <br />
                                <br />
                                <b>Ссылка подписки секретна: не публикуйте её.</b>
                            </div>
                        )}

                        <div className={vpn.line} />

                        {/* Mac */}
                        <div
                            className={vpn.infoText2}
                            onClick={() => toggleSection(3)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && toggleSection(3)}
                        >
                            MacBook, iMac
                            <svg
                                style={{transform: openSection === 3 ? 'rotate(180deg)' : ''}}
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                            >
                                <path d="M5 8L11 14L17 8" stroke="#FFF" strokeWidth="2" strokeLinecap="square" />
                            </svg>
                        </div>
                        {openSection === 3 && isWg && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете выберите протокол <b>Wireguard</b> и страну. Скачайте *.conf или откройте QR.
                                <br />
                                2. Установите{' '}
                                <a href="https://apps.apple.com/ru/app/wireguard/id1451685025?mt=12">WireGuard для macOS</a>.
                                <br />
                                3. Запустите WireGuard, нажмите ➕ → «Импорт туннелей из файла…».
                                <br />
                                4. Укажите скачанный .conf; при ошибке имени переименуйте латиницей.
                                <br />
                                5. Активируйте туннель.
                                <br />
                                <br />
                                <b>Один и тот же QR и файл .conf — только на одном устройстве.</b>
                            </div>
                        )}
                        {openSection === 3 && isAmn && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете нажмите «Добавить VPN-сервер», выберите AmneziaWG и страну. Скачайте *.conf
                                или откройте QR.
                                <br />
                                2. Установите{' '}
                                <a href="https://apps.apple.com/ru/app/amneziawg/id6478942365">приложение AmneziaWG</a>.
                                <br />
                                3. Скачайте файл конфигурации из кабинета.
                                <br />
                                4. Запустите AmneziaWG и нажмите ➕ внизу справа.
                                <br />
                                5. «Импорт из файла или архива», выберите файл из загрузок; при ошибке имени — переименуйте
                                латиницей.
                                <br />
                                6. Включите тумблер.
                                <br />
                                <br />
                                QR можно отсканировать в AmneziaWG через ➕.
                                <br />
                                <b>Один и тот же QR и файл .conf — только на одном устройстве.</b>
                            </div>
                        )}
                        {openSection === 3 && isVless && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете нажмите <b>«VLESS»</b> и скопируйте одну постоянную ссылку.
                                <br />
                                2. Установите{' '}
                                <a href="https://apps.apple.com/ru/app/v2raytun/id6476628951">приложение V2rayTun</a>.
                                <br />
                                3. В v2rayTun: «+» → Import subscription / из буфера обмена.
                                <br />
                                4. Вставьте ссылку и обновите подписку — локации появятся автоматически.
                                <br />
                                5. Российские сервисы работают напрямую; зарубежный трафик идёт через VPN (в Happ — автоматически).
                                <br />
                                <br />
                                <b>Ссылка подписки секретна: не публикуйте её.</b>
                            </div>
                        )}

                        <div className={vpn.line} />

                        {/* Windows */}
                        <div
                            className={vpn.infoText2}
                            onClick={() => toggleSection(4)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && toggleSection(4)}
                        >
                            Windows
                            <svg
                                style={{transform: openSection === 4 ? 'rotate(180deg)' : ''}}
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                            >
                                <path d="M5 8L11 14L17 8" stroke="#FFF" strokeWidth="2" strokeLinecap="square" />
                            </svg>
                        </div>
                        {openSection === 4 && isWg && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете выберите протокол <b>Wireguard</b> и страну. Скачайте *.conf или откройте QR.
                                <br />
                                2. Установите{' '}
                                <a href="https://download.wireguard.com/windows-client/wireguard-installer.exe">WireGuard для Windows</a>{' '}
                                (альтернатива:{' '}
                                <a href="https://www.wireguard.com/install/">wireguard.com/install</a>).
                                <br />
                                3. «Добавить туннель» → «Импорт туннелей из файла» → выберите .conf.
                                <br />
                                4. Подключите туннель.
                                <br />
                                <br />
                                <b>Один и тот же QR и файл .conf — только на одном устройстве.</b>
                            </div>
                        )}
                        {openSection === 4 && isAmn && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете нажмите «Добавить VPN-сервер», выберите AmneziaWG и страну. Скачайте *.conf
                                или откройте QR.
                                <br />
                                2. Установите{' '}
                                <a href="https://github.com/amnezia-vpn/amnezia-client/releases/download/4.8.12.9/AmneziaVPN_4.8.12.9_x64.exe">
                                    приложение AmneziaWG
                                </a>{' '}
                                для Windows.
                                Если выходит ошибка VCRUNTIME140_1.DLL, ее можно исправить <a href={'https://learn.microsoft.com/ru-ru/answers/questions/4030108/msvcp140-1-dll-vcruntime140-1-dll'}>так</a>
                                <br />
                                3. Скачайте файл конфигурации из кабинета.
                                <br />
                                4. Запустите AmneziaWG и нажмите ➕ внизу справа.
                                <br />
                                5. «Импорт из файла или архива», выберите файл из загрузок; при ошибке имени — переименуйте
                                латиницей.
                                <br />
                                6. Включите тумблер.
                                <br />
                                <br />
                                QR можно отсканировать в AmneziaWG через ➕.
                                <br />
                                <b>Один и тот же QR и файл .conf — только на одном устройстве.</b>
                            </div>
                        )}
                        {openSection === 4 && isVless && (
                            <div className={vpn.infoText3}>
                                1. В личном кабинете нажмите <b>«VLESS»</b> и скопируйте одну постоянную ссылку.
                                <br />
                                2. Установите{' '}
                                <a href="https://storage.v2raytun.com/v2RayTun_Setup.exe">приложение V2rayTun</a> для Windows.
                                <br />
                                3. В v2rayTun: «+» → Import subscription / из буфера обмена.
                                <br />
                                4. Вставьте ссылку и обновите подписку — локации появятся автоматически.
                                <br />
                                5. Российские сервисы работают напрямую; зарубежный трафик идёт через VPN (в Happ — автоматически).
                                <br />
                                <br />
                                <b>Ссылка подписки секретна: не публикуйте её.</b>
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Help;
